// extracted by mini-css-extract-plugin
export default {"personStatusOuter":"PersonStatus_personStatusOuter__oavYb","text":"PersonStatus_text__EfJq7"};